// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"delivery-service-module--wrapper--VvNYp","inner":"delivery-service-module--inner--3nbU6","icon":"delivery-service-module--icon--mj0Oq"};